import clsx from 'clsx';
import { endOfDay } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import { useParams } from 'react-router-dom';
import { toTitleCase } from '../../../../../../_metronic/helpers';
import { TldRequestStatus } from '../../../../../pages/tld/mappings';
import { useFilter } from '../../FilterContext';
import MultiSelection from '../../components/MultiSelection';
import SearchInputGroup from '../../components/SearchInputGroup';
import SingleSelection from '../../components/SingleSelection';
import DatePickerFilter from '../components/DatePickerFilter';
import MonthRangePickerFilter from '../components/MonthRangePickerFilter';

export function SitesFilter() {
  const params = useParams();
  const { globalFilter, setGlobalFilter } = useFilter();

  const statusOptions = Object.values(TldRequestStatus).map((status) => ({
    value: status,
    label: toTitleCase(status),
  }));

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        <div className='hstack justify-content-between align-items-end'>
          {/* Select */}
          <div className='d-flex flex-wrap'>
            {/* Active At */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  tldSites: {
                    ...globalFilter.tldSites,
                    active_at: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              label='Active At'
              placeholder='Filter Active At...'
              className='me-6'
            />

            {/* Estimated Next Report */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  tldSites: {
                    ...globalFilter.tldSites,
                    'report_dates.next_at': selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              label='Estimated Next Report'
              placeholder='Filter Estimated Next Report...'
              className='me-6'
            />

            {/* Requested At */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  tldSites: {
                    ...globalFilter.tldSites,
                    requested_at: selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              label='Requested At'
              placeholder='Filter Requested At...'
              className='me-6'
            />

            {/* Status */}
            <MultiSelection
              title='Status'
              globalFilterValue={globalFilter?.tldSites?.status?.values}
              options={statusOptions}
              onChange={(e) => {
                setGlobalFilter({
                  ...globalFilter,
                  tldSites: {
                    ...globalFilter.tldSites,
                    status: { type: 'in', values: e },
                  },
                });
              }}
            />
          </div>
        </div>

        {/* Search */}
        <SearchInputGroup
          inputs={[
            // { key: 'request_id', title: 'Request ID', minWidth: 240 },
            { key: 'merchant_id', title: 'Client ID', minWidth: 240 },
            { key: 'group_name', title: 'Group Name', minWidth: 240 },
            { key: 'mid', title: 'MID', minWidth: 220 },
            { key: 'url', title: 'URL', minWidth: 240 },
            { key: 'request_info.merchant_name', title: 'Merchant Name', minWidth: 240 },
            { key: 'request_info.descriptor', title: 'Descriptor', minWidth: 220 },
            { key: 'request_info.mcc', title: 'MCC', minWidth: 60, maxWidth: 100 },
            { key: 'request_info.remark', title: 'Remark', minWidth: 220 },
          ]}
          section='tldSites'
          globalFilterValue={globalFilter}
          onSubmit={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              tldSites: { ...globalFilter.tldSites, ...searchValues },
            })
          }
          onClear={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              tldSites: { ...globalFilter.tldSites, ...searchValues },
            })
          }
        />
      </div>
    </>
  );
}
